export const Divider = () => (
	<div
		style={{
			flexShrink: '0',
			height: '1px',
			background: '#D8D9E1',
		}}
	/>
);
